import { AlertCircle, CheckCircle2 } from "lucide-react"

interface FormAlertProps {
  tone?: "error" | "success"
  children: React.ReactNode
}

/** Mensagem de erro ou sucesso de formulário, anunciada por leitores de tela. */
export function FormAlert({ tone = "error", children }: FormAlertProps) {
  const error = tone === "error"
  return (
    <div
      role={error ? "alert" : "status"}
      className={`flex gap-2.5 rounded-md border px-3.5 py-3 text-[14px] ${error
        ? "border-negative-200 bg-negative-50 text-negative-800 dark:border-negative-900 dark:bg-negative-950/40 dark:text-negative-200"
        : "border-positive-200 bg-positive-50 text-positive-800 dark:border-positive-900 dark:bg-positive-950/40 dark:text-positive-200"}`}
    >
      {error ? <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" /> : <CheckCircle2 className="h-4 w-4 mt-0.5 shrink-0" />}
      <div>{children}</div>
    </div>
  )
}
